import React, { useState } from 'react';
// import { Icon } from "semantic-ui-react";
import { FaCaretDown } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { ImCross } from "react-icons/im";
import logo from '../../../Assets/landing-page/headerfooter/logo.png'
import menuClasses from '../../../Assets/landing-page/headerfooter/menu-classes.svg'
import menuHome from '../../../Assets/landing-page/headerfooter/menu-home.svg'
import menuNarc from '../../../Assets/landing-page/headerfooter/menu-narc.svg'
import menuSchDashBrd from '../../../Assets/landing-page/headerfooter/menu-schl-dash-brd.svg'
import menuRegistration from '../../../Assets/landing-page/headerfooter/menu-registration.svg'
import blog from '../../../Assets/landing-page/headerfooter/blog.svg'
import menuBook from '../../../Assets/landing-page/headerfooter/menu-book.svg'
import meuTrial from '../../../Assets/landing-page/headerfooter/menu-trial.svg'
import menuCoach from '../../../Assets/landing-page/headerfooter/menu-coach.svg'
import './style.css'
import { AWES_SCHOOL_DASHBOARD_URL, SCHOOL_DASHBOARD_URL, WEB_URL, currentEventCode } from '../../../redux/actions/config';

const Header = () => {
   const [activeMenu, setActiveMenu] = useState(false);
   const mobileMenu = () => {
      activeMenu ? setActiveMenu(false) : setActiveMenu(true);
   };
   const mobileClose = () => {
      setActiveMenu(false);
   };
   const path = window.location.pathname;
   return (
      <header>
         <div className="navbar" onClick={mobileMenu}>
            <GiHamburgerMenu size="1.5em" style={{ marginTop: "5px" }} />
         </div>
         <div className="logo">
            <a href={WEB_URL} target="_blank">
               <img src={logo} alt="Kidex" />
            </a>
         </div>
         <nav className={activeMenu ? "active" : ""}>
            <div className="mobileBG" onClick={mobileClose}></div>
            <ul>
               <div className="logo">
                  <ImCross size="1.2em" style={{ float: "left", margin: "7px 10px 0px 20px" }} onClick={mobileMenu} />
                  <a href='#'><img src={logo} alt="Kidex" /></a>
               </div>
               <li>
                  <a href={WEB_URL} target="_blank">
                     <img src={menuHome} alt="Kidex" className="nav-icon" />
                     Home
                  </a>
               </li>
               <li>
                  <a href={`${WEB_URL}/champions`} target="_blank">
                     <img src={menuNarc} alt="Kidex" className="nav-icon" />
                     Champions
                  </a>
               </li>
               <li>
                  <a href={`${WEB_URL}/class`} target="_blank">
                     <img src={menuClasses} alt="Kidex" className="nav-icon" />
                     Classes
                  </a>
               </li>
               <li className='schl-dshbrd-menu'>
                  <a href={`${AWES_SCHOOL_DASHBOARD_URL}`} target="_blank">
                     <img src={menuSchDashBrd} alt="Kidex" className="nav-icon" />
                     AWES School dashboard
                  </a>
               </li>
               <li className='schl-dshbrd-menu'>
                  <a href={`${SCHOOL_DASHBOARD_URL}`} target="_blank">
                     <img src={menuSchDashBrd} alt="Kidex" className="nav-icon" />
                     All School dashboard
                  </a>
               </li>
               <li className="desktop-dropdown">
                  <a href="#">More <FaCaretDown /></a>
                  <div className="subMenu">
                     <ul>
                        <li>
                           <a href={`${AWES_SCHOOL_DASHBOARD_URL}`} target="_blank">
                              <img src={menuSchDashBrd} alt="Kidex" className="nav-icon" />
                              AWES School dashboard
                           </a>
                        </li>
                        <li>
                           <a href={`${SCHOOL_DASHBOARD_URL}`} target="_blank">
                              <img src={menuSchDashBrd} alt="Kidex" className="nav-icon" />
                              All School dashboard
                           </a>
                        </li>
                        <li>
                           <a href={`${WEB_URL}/champions/leaderboard`} target="_blank">Leaderboard</a>
                        </li>
                        <li>
                           <a href={`${WEB_URL}/class/book-trial`} target="_blank">Book a Trial Class</a>
                        </li>
                        <li>
                           <a href={`${WEB_URL}/class/book-course`} target="_blank">Book a Full Course</a>
                        </li>
                        <li>
                           <a href={`${WEB_URL}/champions/narc`} target="_blank">
                              <img src={menuNarc} alt="Kidex" className="nav-icon" />
                              NARC
                           </a>
                        </li>
                        <li>
                           <a href={`${WEB_URL}/champions/atltnkr2023`} target="_blank">
                              <img src={menuNarc} alt="Kidex" className="nav-icon" />
                              NITI Aayog ATL Tinkerpreneur
                           </a>
                        </li>
                        <li>
                           <a href={`${WEB_URL}/join-as-coach`} target="_blank">Join as Coach</a>
                        </li>
                        <li>
                           <a href={`${WEB_URL}/blogs`} target="_blank">
                              <img src={blog} alt="Kidex" className="nav-icon" />
                              Blogs
                           </a>
                        </li>
                     </ul>
                  </div>
               </li>
               <div className="mobile-dropdown">
                  <li>
                     <a href={`${WEB_URL}/champions/leaderboard`} target="_blank">
                        <img src={menuClasses} alt="Kidex" className="nav-icon" />
                        Leaderboard
                     </a>
                  </li>
                  <li>
                     <a href={`${WEB_URL}/class/book-trial`} target="_blank">
                        <img src={meuTrial} alt="Kidex" className="nav-icon" />
                        Book a Trial Class
                     </a>
                  </li>
                  <li>
                     <a href={`${WEB_URL}/class/book-course`} target="_blank">
                        <img src={menuBook} alt="Kidex" className="nav-icon" />
                        Book a Full Course
                     </a>
                  </li>
                  <li>
                     <a href={`${WEB_URL}/champions/narc`} target="_blank">
                        <img src={menuRegistration} alt="Kidex" className="nav-icon" />
                        NARC
                     </a>
                  </li>
                  <li>
                     <a href={`${WEB_URL}/champions/atltnkr2023`} target="_blank">
                        <img src={menuNarc} alt="Kidex" className="nav-icon" />
                        NITI Aayog ATL Tinkerpreneur
                     </a>
                  </li>
                  <li>
                     <a href={`${WEB_URL}/join-as-coach`} target="_blank">
                        <img src={menuCoach} alt="Kidex" className="nav-icon" />
                        Join as Coach
                     </a>
                  </li>
                  <li>
                     <a href={`${WEB_URL}/blogs`} target="_blank">
                        <img src={blog} alt="Kidex" className="nav-icon" />
                        Blogs
                     </a>
                  </li>
               </div>
            </ul>
         </nav>
         <nav className="booking">
            <ul>
               <li>
                  <a href={`${WEB_URL}/champions/${currentEventCode}/register/individual`} target="_blank">
                     Register for NARC
                  </a>
               </li>
               <li>
                  <a href="https://play.google.com/store/apps/details?id=com.kidex.app&hl=en_IN&gl=US" target="_blank">
                     Get the app
                  </a>
               </li>
            </ul>
         </nav>
      </header>
   );
};

export default Header;
